module.exports = "/images/vendor/vue-paycard/src/dankort.png?4d9ac6aa750bb7941e95b39777dc52c6";